import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import DefenseChat from './components/DefenseChat';
import UnifiedCommerceTwinV1 from './reports/UnifiedCommerceTwinV1';
import FreightLogisticsTwinV1 from './reports/FreightLogisticsTwinV1';
import ReactGA from "react-ga4";
import { PageTracker } from './components/PageTracker';
import HCLSStrategicTwinV1 from './reports/HCLSStrategicTwinV1';
import { FrontierLandingV7 } from './FrontierLandingV7';
import { IndustryBrain } from './IndustryBrain';
import IdeaSpringPortfolio from './ideaspring/IdeaSpringPortfolio';
import IdeaSpringAhummeAnalysis from './ideaspring/IdeaSpringAhummeAnalysis';
import LifeSciencesAnalysis from './analysis/LifeSciencesAnalysis';
import HeavyIndustriesSourcing from './analysis/HeavyIndustriesSourcing';
import TranscropExitAnalysis from './exitAnalysis/TranscropExitAnalysis';
import AhummeExitAnalysis from './exitAnalysis/AhummeExitAnalysis';
import AlliedMarketEntryDossier from './marketEntryAnalysis/AlliedMarketEntryDossier';
import DefenseTechSectorReviewV9 from './reports/DefenseTechSectorReviewV9';
import FrontierPitch from './pitch/FrontierPitch';
import DHLStrategicTwin from './analysis/DHLStrategicTwin';
import DefenseTechSectorBrain from './platformReports/DefenseTechSectorBrain';
import UnifiedCommerceSectorBrain from './platformReports/UnifiedCommerceSectorBrain';
import FreightLogisticsSectorBrain from './platformReports/FreightLogisticsSectorBrain';
import HCLSStrategicSectorBrain from './platformReports/HCLSStrategicSectorBrain';
import AgenticAISectorBrain from './platformReports/AgenticAISectorBrain';
import BatteryMarketMap from './krins/BatteryMarketMap';
import FrontierAgenticBrief from './pitch/FrontierAgenticBrief';
import InvestmentPitch from './pitch/InvestmentPitch';
import MasterclassCatalogue from './pitch/MasterclassCatalogue';
import ParkinsPortfolioStrategy from './analysis/ParkinsPortfolioStrategy';
import { ProductDetail } from './components/landing/ProductDetail';
import CompanyPage from './components/company/CompanyPage';
import ProductsPage from './components/products/ProductsPage';
import DealsPage from './components/deals/DealsPage';
import VideoPage from './videos/VideoPage';

ReactGA.initialize("G-2Y8HNQRW75");

ReactGA.send({ hitType: "pageview", page: window.location.pathname });

export default function App() {
  return (
    <Router>
      <div className="App">
        <PageTracker/>
        <Routes>
          <Route path="/" element={<FrontierLandingV7 />} />
          <Route path="chat" element={<DefenseChat />} />
          <Route path="assets/industry-brain" element= {<IndustryBrain/>} />
          <Route path="ideaspring/portfolio" element={<IdeaSpringPortfolio/>} />
          <Route path="ideaspring/ahammune-analysis" element={<IdeaSpringAhummeAnalysis/>} />
          <Route
            path="intelligence/defense-tech/strategic-sector-review"
            element={<DefenseTechSectorReviewV9/>}
          />
          <Route path="intelligence/retail-tech/strategic-sector-review" element={<UnifiedCommerceTwinV1 />} />
          <Route path="intelligence/logistics/strategic-sector-review" element={<FreightLogisticsTwinV1/>} />
          <Route path="intelligence/health/strategic-sector-review" element={<HCLSStrategicTwinV1/>} />
          <Route path="analysis/life-sciences" element={<LifeSciencesAnalysis/>} />
          <Route path="analysis/heavy-industries" element={<HeavyIndustriesSourcing/>} />
          <Route path="analysis/dhl-innovation" element={<DHLStrategicTwin/>}/>
          <Route path="exit-analysis/transcorp" element={<TranscropExitAnalysis/>}/>
          <Route path="analysis/parkins" element ={<ParkinsPortfolioStrategy/>}/>
          <Route path="exit-analysis/ahumme" element={<AhummeExitAnalysis/>}/>
          <Route path="market-entry/lig" element= {<AlliedMarketEntryDossier/>}/>
          <Route path="pitch" element={<FrontierPitch/>}/>
          <Route path="master-class/catalogue" element={<MasterclassCatalogue/>}/>
          <Route path="investment-pitch" element= {<InvestmentPitch/>}/>
          <Route path="agentic-brief" element={<FrontierAgenticBrief/>}/>
          <Route path="sector-brain/defense-tech" element={<DefenseTechSectorBrain/>}/>
          <Route path="sector-brain/retail-tech" element={<UnifiedCommerceSectorBrain/>}/>
          <Route path="sector-brain/logistics" element={<FreightLogisticsSectorBrain/>}/>
          <Route path="sector-brain/health" element={<HCLSStrategicSectorBrain/>}/>
          <Route path="sector-brain/agentic-ai" element={<AgenticAISectorBrain/>}/>
          <Route path="krins/battery-market-map" element={<BatteryMarketMap />} />
          <Route path="products/:slug" element={<ProductDetail />} />
          <Route path="company" element={<CompanyPage />} />
          <Route path="products" element={<ProductsPage />} />
          <Route path="deals" element={<DealsPage />} />
          <Route path="video" element={<VideoPage />} />
          <Route path="video/:slug" element={<VideoPage />} />
          <Route path="video/*" element={<Navigate to="/video" replace />} />
        </Routes>
      </div>
    </Router>
  );
}
